export default "__VITE_ASSET__jUnqmcsy__"